import { type AxiosInstance } from "axios";
import { type AcquiredPropertiesResponse } from "../types";

export const ACQUIRED_PROPERTIES_ENDPOINT =
  "/picture-request/acquired-properties";

/** 取得済み登記を検索し、通信エラーは呼び出し元のSWRへ伝える */
export const getAcquiredProperties = async (
  apiClient: AxiosInstance,
  params: Record<string, string | number | boolean>
): Promise<AcquiredPropertiesResponse> => {
  const { data } = await apiClient.get<AcquiredPropertiesResponse>(
    ACQUIRED_PROPERTIES_ENDPOINT,
    { params }
  );
  return data;
};
